import { Link } from 'react-router-dom';
import Icon from './Icons';
import Revelar from './Revelar';
import { site, praca } from '../config';
import './Sobre.css';

const formacao = [
  'Advogado',
  'Especialista em Direito Penal e Processo Penal',
  `Inscrito na Ordem dos Advogados do Brasil — ${site.oab}`,
  'Atuação dedicada em Direito Penal e Processo Penal',
  'Atuação em todo Brasil'
];

// Estes quatro blocos falam de posicionamento — onde a atuação alcança e por
// que a base importa. Os compromissos éticos (sigilo, honorários, ausência de
// promessa de resultado) ficam em /sobre, para os textos não se repetirem.
const pilares = [
  {
    icone: 'digitais',
    titulo: 'Atendimento nacional',
    texto:
      'Clientes de qualquer estado são atendidos por videoconferência, com deslocamento presencial quando o ato exige.',
  },
  {
    icone: 'recursos',
    titulo: `Base em ${praca}`,
    texto:
      'O STJ e o STF ficam aqui. Quando o caso sobe aos tribunais superiores, a fase recursal é acompanhada presencialmente.',
  },
  {
    icone: 'relogio',
    titulo: 'Plantão para urgências',
    texto:
      'Prisão em flagrante não espera horário comercial. Casos urgentes são atendidos à noite, em fins de semana e feriados.',
  },
  {
    icone: 'juri',
    titulo: 'Estratégia individual',
    texto:
      'Não há defesa padronizada: cada tese é construída a partir dos autos e das circunstâncias do caso.',
  },
];

export default function Sobre() {
  return (
    <section className="secao secao--escura" id="sobre">
      <div className="container">
        <div className="sobre__grade">
          <Revelar className="sobre__texto">
            <span className="rotulo">O Advogado</span>
            <h2 className="titulo-secao">
              Defesa criminal com técnica, discrição e presença
            </h2>

            <p>
              {site.nome} é advogado dedicado exclusivamente à área criminal, com
              atuação em todas as fases da persecução penal — do inquérito
              policial e da audiência de custódia até a sustentação oral nos
              tribunais e o acompanhamento da execução da pena.
            </p>
            <p>
              O trabalho parte de um princípio simples: nenhum caso é igual ao
              outro. Antes de qualquer tese, vem o estudo minucioso dos autos, a
              conversa franca com o cliente e a definição de uma estratégia
              possível dentro daquilo que os fatos e a prova permitem.
            </p>
            <p>
              O atendimento é conduzido diretamente pelo advogado responsável,
              sem intermediários, e alcança clientes de todos os estados por
              meio de reuniões on-line, com deslocamento para audiências e
              diligências quando o caso exige.
            </p>

            <Link className="sobre__link" to="/sobre">
              Conheça o advogado
              <Icon name="seta" size={17} />
            </Link>

            <figure className="sobre__citacao">
              <blockquote>
                “A ampla defesa não é um favor concedido a quem é acusado. 
                É uma garantia constitucional, e ela precisa ser exercida, acima de tudo, com técnica, 
                desde o primeiro minuto.”
              </blockquote>
              <figcaption>
                {site.nome} · <span>{site.oab}</span>
              </figcaption>
            </figure>
          </Revelar>

          <Revelar className="sobre__lateral" atraso={120}>
            <div className="sobre__cartao">
              <h3>Formação e atuação</h3>
              <ul>
                {formacao.map((item) => (
                  <li key={item}>
                    <Icon name="check" size={16} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Revelar>
        </div>

        <ul className="sobre__pilares">
          {pilares.map((pilar, indice) => (
            <Revelar as="li" key={pilar.titulo} atraso={indice * 90} className="pilar">
              <Icon name={pilar.icone} size={26} />
              <h3>{pilar.titulo}</h3>
              <p>{pilar.texto}</p>
            </Revelar>
          ))}
        </ul>
      </div>
    </section>
  );
}
